import { EditLearningPathFormValues } from "@/schemas/learningPath/useEditLearningPathSchema"
import apiClient from "../client"
import type {
  LearningPathsApiResponse,
  CreateLearningPathApiRequest,
  LearningPathWithModules,
  LearningPath,
  LearningPathApiResponse,
  LearningPathCategory,
  LearningPathStartLetter,
  DownloadUrlResponse,
} from "toptaal-shared"
import type { Filters } from "toptaal-shared"
import { uploadDocument } from "toptaal-shared"

export async function getFilteredLearningPaths(
  filters: {
    learningPathCategory: LearningPathCategory | "all"
  } & Filters,
) {
  const { learningPathCategory, ...restFilters } = filters

  return await apiClient
    .post<LearningPathsApiResponse>(
      `learning_paths/filters/${learningPathCategory}`,
      {
        json: {
          restFilters,
        },
      },
    )
    .json()
}

export async function getLearningPathWithModules(
  learningPathId: LearningPath["id"],
) {
  return await apiClient
    .get<LearningPathWithModules>(`learning_paths/${learningPathId}`)
    .json()
}

export async function createLearningPath(
  request: CreateLearningPathApiRequest,
) {
  return await apiClient
    .post<{ data: LearningPathApiResponse }>("learning_paths", {
      json: request,
    })
    .json()
}

export async function editLearningPath({
  values,
  learningPathId,
}: {
  values: EditLearningPathFormValues
  learningPathId: LearningPath["id"]
}) {
  return await apiClient
    .put(`learning_paths/${learningPathId}`, {
      json: {
        id: learningPathId,
        learningPath: {
          ...values,
        },
      },
    })
    .json()
}

export async function uploadLearningPathStartLetter({
  learningPathId,
  file,
  displayFilename,
}: {
  learningPathId: LearningPath["id"]
  file: File
  displayFilename: string
}) {
  return uploadDocument(
    { file, displayFilename },
    { endpoint: `learning_paths/${learningPathId}/documents` },
  )
}

export async function getLearningPathStartLetterUrl(
  learningPathId: LearningPath["id"],
  documentId: LearningPathStartLetter["id"],
  options: { disposition: "inline" | "attachment" },
) {
  return await apiClient
    .get<DownloadUrlResponse>(
      `learning_paths/${learningPathId}/documents/${documentId}`,
      { headers: { disposition: options.disposition } },
    )
    .json()
}

export async function deleteLearningPathStartLetter(
  learningPathId: LearningPath["id"],
  documentId: LearningPathStartLetter["id"],
) {
  return await apiClient
    .delete(`learning_paths/${learningPathId}/documents/${documentId}`)
    .json()
}
